import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './dialog';
import { Button } from './button';
import { AlertTriangle, ArrowRight, Settings, MessageSquare, Clock } from 'lucide-react';

export default function MaintenanceModal({ isOpen, onClose, onNavigateToSettings, onNavigateToSupport }) {
  const handleRedirect = () => {
    window.location.href = '/';
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-6 w-6 text-amber-500" />
            <DialogTitle>Core Features Under Maintenance</DialogTitle>
          </div>
          <DialogDescription className="text-left">
            Our transcription and SOAP note generation features are currently under maintenance. 
            However, you can still access your existing data and other features.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-sm text-amber-800">
              <strong>What's temporarily unavailable:</strong><br />
              • Live transcription recording<br />
              • Audio file uploads<br />
              • New SOAP note generation
            </p>
          </div>

          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <p className="text-sm text-green-800">
              <strong>What you can still access:</strong><br />
              • View and edit existing SOAP notes<br />
              • Account settings and preferences<br />
              • Support tickets and help center<br />
              • Template library
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <Button 
              onClick={onNavigateToSettings}
              variant="outline"
              className="flex items-center justify-center gap-2"
            >
              <Settings className="h-4 w-4" />
              Settings
            </Button>
            <Button 
              onClick={onNavigateToSupport}
              variant="outline"
              className="flex items-center justify-center gap-2"
            >
              <MessageSquare className="h-4 w-4" />
              Support
            </Button>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-2">
            <Button 
              onClick={handleRedirect}
              className="flex-1"
            >
              Go to Homepage
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button 
              variant="outline" 
              onClick={onClose}
              className="flex-1"
            >
              <Clock className="mr-2 h-4 w-4" />
              Wait & Continue
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}